<template>
    <section class="product-view-page">
        <div class="single_product mt-5">
            <div class="container">
                <div class="row mt-5">
                    <div class="col-md-8">
                        <h4 class="mb-3">Registered Delivery Address</h4>
                        <h5><b-badge>{{ shipping }}</b-badge></h5>
                        <div class="alert alert-primary">
                            You are not allowed to use a custom shipping address for your order. All of your orders will be delivered to your registered address. If you need to update your delivery address please contact True Wholesale administrator.
                        </div>
                    </div>
                    <div class="col-md-4">
                        <h4 class="d-flex justify-content-between align-items-center mb-3">
                            <span>Your cart</span>
                            <span class="badge badge-primary badge-pill">
                                {{ items.length }}
                            </span>
                        </h4>
                        <ul class="list-group mb-3">
                            <li class="list-group-item d-flex justify-content-between lh-condensed">
                                <div>
                                    <h6 class="my-0">Subtotal</h6>
                                </div>
                                <span class="text-muted">
                                    <i class="fas fa-rupee-sign mr-1"></i>
                                    {{ subtotal }}
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between lh-condensed"
                                v-if="tax > 0">
                                <div>
                                    <h6 class="my-0">Tax</h6>
                                </div>
                                <span class="text-muted">
                                    <i class="fas fa-rupee-sign mr-1"></i>
                                    {{ tax }}
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between lh-condensed"
                                v-if="discount > 0">
                                <div>
                                    <h6 class="my-0">Discount</h6>
                                    <small class="text-muted">Referral Points</small>
                                </div>
                                <span class="text-muted">
                                    <i class="fas fa-rupee-sign mr-1"></i>
                                    {{ discount }}
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between lh-condensed"
                                v-if="deliveryCharge > 0">
                                <div>
                                    <h6 class="my-0">Delivery Charges</h6>
                                </div>
                                <span class="text-muted">
                                    <i class="fas fa-rupee-sign mr-1"></i>
                                    {{ deliveryCharge }}
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between lh-condensed"
                                v-if="paymentMethod == 'COD' && codCharge > 0">
                                <div>
                                    <h6 class="my-0">COD Charges</h6>
                                </div>
                                <span class="text-muted">
                                    <i class="fas fa-rupee-sign mr-1"></i>
                                    {{ codCharge }}
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between">
                                <span>Total</span>
                                <strong>
                                    <i class="fas fa-rupee-sign mr-1"></i>
                                    {{ total }}
                                </strong>
                            </li>
                        </ul>
                        <div class="alert alert-info"
                            v-if="freeDeliveryMessage"
                            v-html="freeDeliveryMessage">
                        </div>
                        <ul class="list-group mb-3">
                            <li class="list-group-item d-flex justify-content-between lh-condensed">
                                <b-form-group label="Payment Options" 
                                    v-slot="{ ariaDescribedby }">
                                    <b-form-radio-group v-model="paymentMethod"
                                        :aria-describedby="ariaDescribedby"
                                        name="payment-option"
                                        @change="changePaymentMethod"
                                        stacked>
                                        <b-form-radio value="UPI">
                                            UPI
                                        </b-form-radio>
                                        <b-form-radio value="COD"
                                            v-if="codEligible">
                                            Cash on delivery
                                            <b-badge variant="primary"
                                                v-if="codCharge > 0">
                                                <i class="fas fa-rupee-sign mr-1"></i>
                                                {{ codCharge }}
                                            </b-badge>
                                            <b-badge variant="success"
                                                v-else>
                                                Free
                                            </b-badge>
                                        </b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </li>
                        </ul>
                        <a href="javascript:void(0)" 
                            v-if="items.length > 0"
                            class="update-cart w-100 text-center"
                            @click="processOrder(false)">
                            Payment Now
                        </a>
                        <a :href="appUrl+'/shopping-cart'" 
                            class="shopping-cart-black w-100 text-center mt-2">
                            Shopping Cart
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        computed: {},
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
                items: [],
                subtotal: 0,
                discount: 0,
                tax: 0,
                total: 0,
                deliveryCharge: 0,
                freeDeliveryMessage: null,
                codEligible: false,
                codCharge: 0,
                paymentMethod: 'UPI',
                razorpay_key: null,
                shipping: null,
                validationErrors: null,
                paymentError: null,
            };
        },
        mounted() {
            const checkoutScript = document.createElement("script");
            checkoutScript.setAttribute(
                "src",
                "//checkout.razorpay.com/v1/checkout.js"
            );
            checkoutScript.async = true;
            document.head.appendChild(checkoutScript);
            this.getCartItems();
            this.getSavedAddress();
            this.getRazorpayKey();
        },
        methods: {
            changePaymentMethod(method) {
                var that = this;
                var newTotal;
                if (method == 'COD') {
                    newTotal = parseFloat(that.total) + parseFloat(that.codCharge);
                } else {
                    newTotal = parseFloat(that.total) - parseFloat(that.codCharge);
                }
                that.total = newTotal.toFixed(2)
            },
            getCartItems() {
                var that = this;
                axios.get('api/get-cart-items')
                .then(function(response) {
                    that.items = response.data.items;
                    that.subtotal = response.data.subtotal;
                    that.tax = response.data.tax;
                    that.discount = response.data.discount;
                    that.total = response.data.total;
                    that.deliveryCharge = response.data.delivery_charge;
                    that.freeDeliveryMessage = response.data.free_delivery_message;
                    that.codCharge = response.data.cod_charge;
                    that.codEligible = response.data.cod_eligible;
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            getSavedAddress() {
                var that = this;
                axios.get('api/get-address')
                .then(function(response) {
                    that.shipping = response.data.address;
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            getRazorpayKey() {
                var that = this;
                axios.get('api/get-razorpay-key')
                .then(function(response) {
                    that.razorpay_key = response.data.key;
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            validateCheckout() {
                var that = this;
                axios.post('api/validate-checkout', {
                    payment_method: that.paymentMethod,
                })
                .then(function(response) {
                    if (response.data.success == false) {
                        that.validationErrors = response.data.errors;
                    } else {
                        that.validationErrors = null;
                        that.processOrderOnline();
                    }
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            processOrder(saveTransaction) {
                var that = this;
                if (that.paymentMethod == 'UPI' && saveTransaction == false) {
                    that.validateCheckout();
                } else  { 
                    axios.post('api/checkout', {
                        payment_method: that.paymentMethod,
                    })
                    .then(function(response) {
                        if (response.data.success == false) {
                            that.validationErrors = response.data.errors;
                        } else {
                            that.validationErrors = null;
                            window.location.href = that.appUrl+'/thank-you/'+response.data.order_number;
                        }
                    })
                    .catch(function (response) {
                        console.log(response);
                        alert('Something went wrong, please try again.');
                    });
                }
            },
            processOrderOnline() {
                var that = this;
                var totalAmount = that.total * 100;
                var orderNumber = new Date().getTime();
                var options = {
                    "key": that.razorpay_key,
                    "amount": totalAmount,
                    "currency": "INR",
                    "name": "True Wholesale",
                    "description": "True Wholesale Transaction",
                    "image": "https://provisdemo.com/true-wholesale/public/guest/images/True-Wholesale.png",
                    "handler": function (response){
                        axios.post('api/payment', {
                            razorpay_payment_id: response.razorpay_payment_id,
                        })
                        .then(function(response) {
                            if (response.data.success == false) {
                                that.paymentError = response.data.payment_error;
                            } else {
                                that.paymentError = null;
                                that.processOrder(true);
                            }
                        })
                        .catch(function (response) {
                            console.log(response);
                            alert('Something went wrong, please try again.');
                        });
                    },
                };
                var razorPay = new Razorpay(options);
                razorPay.open();
            }
        }
    };
</script>
